import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import React from "react";
import { useContext } from "react";
import ReportContext from "../../context/500/ReportContext";
import ReportMainLayout from "./ReportMainLayout";
import Select from "@mui/material/Select";
import { FormControl, InputLabel, MenuItem } from "@mui/material";

function ReportHeader() {
  let {
    openReport,
    setOpenReport,
    admissionForReport,
    setadmissionForReport,
    programForReport,
    setProgramForReport,
  } = useContext(ReportContext);

  return (
    <React.Fragment>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: "20px",
        }}
      >
        {openReport === false ? (
          <h3
            style={{
              color: "#cd853f",
              marginLeft: "35px",
            }}
          >
            Open Report
          </h3>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <FormControl
              size="small"
              sx={{
                width: "130px",
                marginLeft: "15px",
              }}
            >
              <InputLabel id="demo-simple-select-label">Admission</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={admissionForReport}
                label="Batch"
                onChange={(e) => {
                  setadmissionForReport(e.target.value);
                }}
              >
                <MenuItem value={"all"}>All</MenuItem>
                <MenuItem value={"Regular"}>Regular</MenuItem>
                <MenuItem value={"Extension"}>Extension</MenuItem>
              </Select>
            </FormControl>

            <FormControl
              size="small"
              sx={{
                width: "100px",
                marginLeft: "15px",
              }}
            >
              <InputLabel id="demo-simple-select-label">Program</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={programForReport}
                label="Batch"
                onChange={(e) => {
                  setProgramForReport(e.target.value);
                }}
              >
                <MenuItem value={"all"}>All</MenuItem>
                <MenuItem value={"BSc"}>UG</MenuItem>
                <MenuItem value={"Masters"}>Msc</MenuItem>
                <MenuItem value={"Phd"}>Phd</MenuItem>
              </Select>
            </FormControl>
          </div>
        )}

        {openReport === false ? (
          <KeyboardArrowDownIcon
            sx={{
              cursor: "pointer",
              marginRight: "35px",
            }}
            onClick={() => {
              setOpenReport(true);
              setadmissionForReport("all");
              setProgramForReport("all");
            }}
          />
        ) : (
          <KeyboardArrowUpIcon
            sx={{
              cursor: "pointer",
              marginRight: "35px",
            }}
            onClick={() => {
              setOpenReport(false);
            }}
          />
        )}
      </div>
      {openReport === true && <ReportMainLayout />}
    </React.Fragment>
  );
}

export default ReportHeader;
